import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function NutritionStats() {
  return <section className="py-12 md:py-16 px-4 bg-red-50/50" data-id="element-127">
      <div className="max-w-2xl mx-auto" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-[#FEF2F2]/80 backdrop-blur-sm rounded-3xl border border-red-100 shadow-[0_8px_40px_rgba(180,40,40,0.06)] px-6 py-8 md:px-10 md:py-10 text-center" data-id="element-129">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-130">
            <h2 className="text-3xl md:text-4xl lg:text-[2.75rem] font-bold font-serif text-charcoal leading-snug mb-5" data-id="element-131">
              ¿Sabías que el{' '}
              <span className="font-extrabold text-red-500" data-id="element-132">85%</span> de las{' '}
              <span className="font-extrabold text-red-500" data-id="element-133">
                enfermedades graves
              </span>{' '}
              en perros se deben a una mala nutrición?
            </h2>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.15
        }} className="space-y-3 mb-6" data-id="element-134">
            <p className="text-lg md:text-xl text-gray-600 leading-normal" data-id="element-135">
              Los cuerpos de nuestros perros no están diseñados para consumir
              alimentos altamente procesados.
            </p>
            <p className="text-lg md:text-xl text-gray-600 leading-normal" data-id="element-136">
              Por el contrario, alcanzan plenitud y salud cuando los alimentos
              se preparan de forma{' '}
              <strong className="text-charcoal" data-id="element-137">natural y fresca</strong>, sin
              conservantes ni aditivos.
            </p>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          delay: 0.3
        }} className="text-xl md:text-2xl font-semibold text-charcoal font-serif mb-6" data-id="element-138">
            Por eso creamos una guía simple para que puedas hacerlo bien desde
            el primer día.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.4
        }} className="flex justify-center" data-id="element-139">
            <CTAButton text="QUIERO EMPEZAR AHORA MISMO" className="!bg-[#DF5607] hover:!bg-[#c44a06] hover:!shadow-[0_8px_24px_rgba(223,86,7,0.35)]" data-id="element-140" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}